import axios from 'axios';

// Créer une instance d'Axios pour gérer les requêtes utilisateur
const requestUser = axios.create({
  baseURL: 'http://localhost:8081/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ajouter un intercepteur pour attacher le token dans les headers Authorization
requestUser.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Récupérer le token depuis localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Ajouter le token dans les headers
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Ajouter un intercepteur pour gérer les réponses
requestUser.interceptors.response.use(
  (response) => response,
  (error) => {
    // Traitez les erreurs ici
    console.error('Erreur dans la réponse:', error);
    return Promise.reject(error);
  }
);

export default requestUser;
